var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJudge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "navi-dashboard-judge",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "navi-dashboard-judge-2",
    "data-name": "navi-dashboard-judge",
    d: "M17.708,0H2.292A2.294,2.294,0,0,0,0,2.292V17.708A2.294,2.294,0,0,0,2.292,20H17.708A2.294,2.294,0,0,0,20,17.708V2.292A2.294,2.294,0,0,0,17.708,0ZM4.583,12.083A2.083,2.083,0,1,1,6.667,10,2.086,2.086,0,0,1,4.583,12.083Zm5.417,0A2.083,2.083,0,1,1,12.083,10,2.086,2.086,0,0,1,10,12.083Zm5.417,0A2.083,2.083,0,1,1,17.5,10,2.086,2.086,0,0,1,15.417,12.083Zm0,0",
    transform: "translate(20) rotate(90)",
    fill: "#d6d6d6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJudge);
export default __webpack_public_path__ + "static/media/judge.72ba0ed9012fec7bb3c93144dc9b882c.svg";
export { ForwardRef as ReactComponent };